import { z } from "zod";

/** A coordinate from the URL, or nothing when it isn't one in range. */
const coordinate = (limit: number) =>
  z.coerce.number().min(-limit).max(limit).optional().catch(undefined);

/** Create POI's `?lat=&lng=`: the spot picked on the POI screen's map
 *  ("Create POI here"), filled into the form. */
export const poiCreateSearchSchema = z.object({
  lat: coordinate(90),
  lng: coordinate(180),
});

export type PoiCreateSearch = z.infer<typeof poiCreateSearchSchema>;
